<div mat-dialog-content>
  <form class="register-form m-4">
    <div class="row">
      <div class="col-12 mb-6">
        <label class="campo-plano-label">Estado</label>
        <mat-form-field class="example-full-width campo-plano" appearance="outline">
          <mat-select [(ngModel)]="codEstadoEst" name="codEstadoEst" (selectionChange)="onEstadoChange()" required (openedChange)="buscaEstado = ''" placeholder="Selecione...">
            <div class="select-busca" (click)="$event.stopPropagation()">
              <i-lucide name="search" size="16" class="select-busca-icone"></i-lucide>
              <input
                type="text"
                class="select-busca-input"
                placeholder="Buscar estado..."
                title="Buscar estado"
                [(ngModel)]="buscaEstado"
                [ngModelOptions]="{ standalone: true }"
                (keydown)="$event.stopPropagation()">

              <button
                type="button"
                class="select-busca-limpar"
                title="Limpar busca"
                aria-label="Limpar busca"
                *ngIf="buscaEstado"
                (click)="buscaEstado = ''; $event.stopPropagation()">
                <i-lucide name="x" size="14"></i-lucide>
              </button>
            </div>

            <mat-option *ngFor="let item of filtrarOpcoes(estado, buscaEstado, ['desNomeEstadoEst'])" [value]="item.codEstadoEst">{{item.desNomeEstadoEst}}</mat-option>

            <div class="select-vazio" *ngIf="filtrarOpcoes(estado, buscaEstado, ['desNomeEstadoEst']).length === 0">
              Nenhum estado encontrado
            </div>

          </mat-select>
          <mat-icon class="material-icons-outlined color-icon p-3" matSuffix>gavel</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-2">
        <label class="campo-plano-label">Município</label>
        <mat-form-field class="example-full-width campo-plano" appearance="outline">
          <mat-select [(ngModel)]="codMunicipioMun" name="codMunicipioMun" (selectionChange)="onMunicipioChange()"
            placeholder="Selecione..."
            required [disabled]="!municipio.length" (openedChange)="buscaMunicipio = ''">
            <div class="select-busca" (click)="$event.stopPropagation()">
              <i-lucide name="search" size="16" class="select-busca-icone"></i-lucide>
              <input
                type="text"
                class="select-busca-input"
                placeholder="Buscar município..."
                title="Buscar município"
                [(ngModel)]="buscaMunicipio"
                [ngModelOptions]="{ standalone: true }"
                (keydown)="$event.stopPropagation()">

              <button
                type="button"
                class="select-busca-limpar"
                title="Limpar busca"
                aria-label="Limpar busca"
                *ngIf="buscaMunicipio"
                (click)="buscaMunicipio = ''; $event.stopPropagation()">
                <i-lucide name="x" size="14"></i-lucide>
              </button>
            </div>

            <mat-option *ngFor="let item of filtrarOpcoes(municipio, buscaMunicipio, ['desNomeMun'])" [value]="item.codMunicipioMun">{{item.desNomeMun}}</mat-option>

            <div class="select-vazio" *ngIf="filtrarOpcoes(municipio, buscaMunicipio, ['desNomeMun']).length === 0">
              Nenhum município encontrado
            </div>

          </mat-select>
          <mat-icon class="material-icons-outlined color-icon p-3" matSuffix>home_work</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-2">
        <label class="campo-plano-label">Órgão</label>
        <mat-form-field class="example-full-width campo-plano" appearance="outline">
          <mat-select [(ngModel)]="codOrgaoOrg" name="codOrgaoOrg" required [disabled]="!orgaoFiltrado.length" (openedChange)="buscaOrgao = ''" placeholder="Selecione...">
            <div class="select-busca" (click)="$event.stopPropagation()">
              <i-lucide name="search" size="16" class="select-busca-icone"></i-lucide>
              <input
                type="text"
                class="select-busca-input"
                placeholder="Buscar órgão..."
                title="Buscar órgão"
                [(ngModel)]="buscaOrgao"
                [ngModelOptions]="{ standalone: true }"
                (keydown)="$event.stopPropagation()">

              <button
                type="button"
                class="select-busca-limpar"
                title="Limpar busca"
                aria-label="Limpar busca"
                *ngIf="buscaOrgao"
                (click)="buscaOrgao = ''; $event.stopPropagation()">
                <i-lucide name="x" size="14"></i-lucide>
              </button>
            </div>

            <mat-option *ngFor="let item of filtrarOpcoes(orgaoFiltrado, buscaOrgao, ['desNomeOrg'])" [value]="item.codOrgaoOrg">{{item.desNomeOrg}}</mat-option>

            <div class="select-vazio" *ngIf="filtrarOpcoes(orgaoFiltrado, buscaOrgao, ['desNomeOrg']).length === 0">
              Nenhum órgão encontrado
            </div>

          </mat-select>
          <mat-icon class="material-icons-outlined color-icon p-3" matSuffix>account_balance</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-2" align="end">
        <button mat-raised-button color="primary" style="margin-right: 8px;" (click)="confirmAdd()"
          [disabled]="!codEstadoEst || !codMunicipioMun || !codOrgaoOrg">
          Salvar
        </button>
        <button mat-raised-button color="warn" (click)="onNoClick()">Cancelar</button>
      </div>
    </div>
  </form>
</div>